import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Home, MapPin, Star, FileText, Wrench } from 'lucide-react';

const trustItems = [
  { icon: Shield, label: 'Licensed & Insured — Up to $1M' },
  { icon: Home, label: 'Locally Owned & Operated' },
  { icon: FileText, label: 'Free Estimates' },
  { icon: Wrench, label: 'Residential & Light Commercial' },
  { icon: MapPin, label: 'Rockport · Corpus Christi · Coastal Bend' },
  { icon: Star, label: 'Quality Work Starts with Quality Preparation' },
];

export default function TrustBar() {
  return (
    <section className="relative bg-[#111111] border-t border-white/10 border-b border-white/10">
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 py-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-5">
          {trustItems.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex items-center gap-3"
            >
              <div className="w-9 h-9 rounded-sm bg-[#C97B2E]/15 flex items-center justify-center flex-shrink-0">
                <item.icon className="w-4 h-4 text-[#C97B2E]" />
              </div>
              <span className="font-body text-white/70 text-xs font-bold tracking-wide leading-snug">
                {item.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}